<template>
    <v-input-text
        :value="value"
        :label="label"
        :placeholder="placeholder"
        :disabled="disabled"
        :readonly="readonly"
        :caption="caption"
        :autocomplete="autocomplete"
        :error="error"
        :name="name"
        :maxlength="maxlength"
        :theme="theme"
        mask="date"
        @input="$emit('input', $event)"
        @assistant-outside-click="isShowDatePicker = false"
    >
        <template slot="assistant-action" scope="props">
            <v-icon-button @click="handleTogglePicker">
                date_range
            </v-icon-button>
        </template>

        <template slot="assistant" scope="props">
            <v-date-picker-raw
                v-model="cacheValue"
                :label="dateLabel"
                format="DD/MM/YYYY"
                v-if="isShowDatePicker"
            >
                <v-button flat primary @click="isShowDatePicker = false" v-margin.right="2">
                    отмена
                </v-button>

                <v-button flat primary @click="handleSelect">
                    ок
                </v-button>
            </v-date-picker-raw>
        </template>
    </v-input-text>
</template>

<script>
    import { vButton } from '../Button';
    import { vInputText } from '../InputText';
    import { Shadow } from '../../directives';

    export default {
        name: 'input-date',
        components: {
            vInputText,
            vButton,
        },
        directives: {
            Shadow
        },
        props: {
            value: [String, Number],
            dateLabel: String,
            label: String,
            placeholder: String,
            disabled: Boolean,
            readonly: Boolean,
            caption: String,
            autocomplete: String,
            error: String,
            name: String,
            maxlength: String,
            theme: Object
        },
        data() {
            return {
                isShowDatePicker: false,
                isOver: false,
                cacheValue: this.value,
            }
        },
        watch: {
            value(newValue) {
                this.cacheValue = newValue;
            }
        },
        methods: {
            handleSelect() {
                this.$emit('input', this.cacheValue);
                this.isShowDatePicker = false;
            },
            handleTogglePicker() {
                if (!this.isShowDatePicker) {
                    this.cacheValue = this.value;
                }

                this.isShowDatePicker = !this.isShowDatePicker;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// InputDate.vue?598c15d2